module.exports = __webpack_public_path__ + "static/media/play-store.e7a5cd3a.png";